<div class="video-detail live-video-detail">
  <div class="player">
    <app-vjs-player [options]="{
        aspectRatio: '16:9',
        autoplay: false,
        poster:
          'https://d1tcjcrle6fjgd.cloudfront.net/series/1615284389599.png',
        sources: [
          {
            src:
              'https://www.radiantmediaplayer.com/media/big-buck-bunny-360p.mp4',
            type: 'video/mp4'
          }
        ]
      }">
    </app-vjs-player>
    <div class="live-page-head">
      <div class="d-flex align-items-start heading-box">
        <a href="javascript:void(0)" class="back-btn font-24 mr-2">
          <span class="mdi mdi-arrow-left"></span>
        </a>
        <div>
          <h5 class="font-bold">
            Imagine Dragons-Believer-Pinkpop 2017 (HD Live Show)
          </h5>
          <span class="live-batch"> Live </span>
        </div>
      </div>
      <div class="social-btn-group mt-0">
        <div class="d-flex align-items-center all-btns-box pt-0">
          <div class="d-flex align-items-start icons-box">
            <div class="social-icons">
              <button mat-button class="circle-btn">
                <span class="social-icon icon-like-border"></span>
              </button>
            </div>
            <div class="social-icons">
              <button mat-button class="circle-btn">
                <span class="social-icon icon-dis-like-border"></span>
              </button>
            </div>
            <div class="social-icons">
              <button mat-button class="circle-btn">
                <span class="social-icon icon-forword"></span>
              </button>
            </div>
            <!-- <div *ngIf="videoDetail?.source == 'system'" class="social-icons">
              <button matTooltip="{{ 'VIDEO_DETAIL.SHARE_TIP' | translate }}" class="circle-btn" mat-button
                [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <span class="social-icon icon-forword"></span>
                <mat-menu class="share-dropdown" #menu="matMenu">
                  <share-button *ngIf="
                      videoDetail?.type == 'video' &&
                      videoDetail?.source == 'system'
                    " [size]="10" button="facebook" url="{{ appConstant.shareUrl + 'video-detail/' + public_id }}">
                  </share-button>
                  <share-button *ngIf="
                      videoDetail?.type == 'video' &&
                      videoDetail?.source == 'system'
                    " [size]="10" button="twitter" url="{{ appConstant.shareUrl + 'video-detail/' + public_id }}">
                  </share-button>
                  <share-button *ngIf="
                      videoDetail?.type == 'series' &&
                      videoDetail?.source == 'system'
                    " [size]="10" button="facebook" url="{{ appConstant.shareUrl + 'series-detail/' + public_id }}">
                  </share-button>
                  <share-button *ngIf="
                      videoDetail?.type == 'series' &&
                      videoDetail?.source == 'system'
                    " [size]="10" button="twitter" url="{{ appConstant.shareUrl + 'series-detail/' + public_id }}">
                  </share-button>
                </mat-menu>
              </button>
            </div> -->
            <div class="social-icons">
              <button mat-button class="circle-btn">
                <span class="social-icon icon-flag"></span>
              </button>
            </div>
          </div>
          <button type="button" class="btn btn-theme ml-2" (click)="chatShowHide(chatStatus)">
            {{ chatStatus }}
            <span class="mdi font-18 ml-2" [ngClass]="{
                'mdi-chevron-up': chatStatus === 'Hide Chat',
                'mdi-chevron-down': chatStatus === 'Show Chat'
              }"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="chatStatus === 'Hide Chat'">
  <app-social-chat></app-social-chat>
</div>